var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineShape02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74001 4.08346L4.75076 4.08229L4.76141 4.08034C5.61827 3.92395 6.45486 4.56925 6.57693 5.50211C7.21732 10.5375 7.83643 15.7158 7.73367 20.8373C7.70817 21.7243 6.96059 22.4541 6.06199 22.4188L6.06193 22.4188C5.14842 22.3831 4.4306 21.6162 4.45463 20.7373L4.45466 20.7359C4.56666 15.8013 3.94206 10.7412 3.31781 5.86589C3.21593 5.01944 3.8455 4.18084 4.74001 4.08346Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0294 27.9485L20.0294 27.9486C23.8136 24.365 27.3822 20.5664 30.9605 16.7576C31.2875 16.4095 31.6146 16.0613 31.942 15.7132C35.8488 11.5588 39.7903 7.41574 44.0459 3.56756L44.0511 3.56286L44.0512 3.56292C44.7119 2.99299 44.7706 1.94915 44.1652 1.28331L20.0294 27.9485ZM20.0294 27.9485L20.0255 27.9524M20.0294 27.9485L20.0255 27.9524M20.0255 27.9524C19.3843 28.5821 18.3495 28.5174 17.7121 27.909C17.0948 27.2429 17.1205 26.1959 17.7775 25.5487C21.5854 21.953 25.1762 18.1425 28.7626 14.3367C29.091 13.9882 29.4194 13.6398 29.7479 13.2915C33.6669 9.13679 37.6053 5.01023 41.8528 1.18039L41.8529 1.18049M20.0255 27.9524L41.8529 1.18049M41.8529 1.18049L41.8595 1.17414M41.8529 1.18049L41.8595 1.17414M41.8595 1.17414C42.5224 0.53855 43.5539 0.611941 44.1652 1.28328L41.8595 1.17414Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4678 33.2942L42.4678 33.2943L42.4735 33.2925C43.5033 32.9622 44.5284 33.4866 44.7783 34.2599C45.0462 35.1053 44.502 36.0848 43.4704 36.417C40.8154 37.2102 38.1604 38.0033 35.5052 38.7964C33.0753 39.5222 30.6453 40.2481 28.215 40.9741C27.1439 41.2409 26.1511 40.7734 25.8902 39.9355C25.6264 39.0852 26.1799 38.1119 27.2134 37.8518L27.2135 37.8521L27.2261 37.8483C29.6537 37.1229 32.0811 36.3977 34.5085 35.6724C37.1617 34.8797 39.8148 34.087 42.4678 33.2942Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineShape02);
export default __webpack_public_path__ + "static/media/line_shape02.fe2c298a94635afcfbb054a46aec5a83.svg";
export { ForwardRef as ReactComponent };